import { format, parse } from 'date-fns'

/** Two month pickers ("October, 2026 – October, 2026"). Values are 'YYYY-MM'.
 *  Keeps from ≤ to: moving one past the other drags the other along. */
export default function MonthRangePicker({
  from, to, onChange, max,
}: {
  from: string
  to: string
  onChange: (from: string, to: string) => void
  max?: string
}) {
  const label = (m: string) => format(parse(m, 'yyyy-MM', new Date()), 'MMMM, yyyy')
  return (
    <div className="flex items-center gap-1.5 rounded-lg bg-gray-50 px-2 py-1 text-xs text-gray-600" title={`${label(from)} – ${label(to)}`}>
      <input
        type="month" value={from} max={max}
        onChange={(e) => e.target.value && onChange(e.target.value, e.target.value > to ? e.target.value : to)}
        className="bg-transparent text-xs focus:outline-none"
        aria-label="From month"
      />
      <span>–</span>
      <input
        type="month" value={to} max={max}
        onChange={(e) => e.target.value && onChange(e.target.value < from ? e.target.value : from, e.target.value)}
        className="bg-transparent text-xs focus:outline-none"
        aria-label="To month"
      />
    </div>
  )
}

/** First and last calendar day ('YYYY-MM-DD') for a 'YYYY-MM' range, with the
 *  end capped at today so future days aren't requested. */
export function monthRangeDates(from: string, to: string, today: string): [string, string] {
  const start = `${from}-01`
  const [y, m] = to.split('-').map(Number)
  const last = new Date(y, m, 0)
  const end = format(last, 'yyyy-MM-dd')
  return [start, end > today ? today : end]
}
